import { FORM_TOKENS_STORE_NAME } from '../../constants';
import { FormTokenMetaRecord } from '../../types/context';
import { getFormTokenMetaKeyRange } from './getFormTokenMetaKeyRange';
import { openFormTokensDb } from './openFormTokensDb';

// null = the read FAILED (unavailable/transient error) — callers must not treat
// it as an empty store, that would permanently detach the blob's references
export const getAllFormTokenMetaRecords = async (
  storageKey: string
): Promise<FormTokenMetaRecord[] | null> => {
  const db = await openFormTokensDb();
  if (!db) {
    return null;
  }

  const storedValues = await new Promise<unknown[] | null>((resolve) => {
    try {
      const request = db
        .transaction(FORM_TOKENS_STORE_NAME, 'readonly')
        .objectStore(FORM_TOKENS_STORE_NAME)
        .getAll(getFormTokenMetaKeyRange(storageKey));
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => resolve(null);
    } catch {
      resolve(null);
    }
  });

  if (storedValues === null) {
    return null;
  }

  const records: FormTokenMetaRecord[] = [];
  storedValues.forEach((storedValue) => {
    if (typeof storedValue !== 'string') {
      return;
    }
    try {
      const parsed: Partial<FormTokenMetaRecord> = JSON.parse(storedValue);
      if (typeof parsed?.id === 'string' && parsed.meta) {
        records.push({ id: parsed.id, meta: parsed.meta });
      }
    } catch {
      // corrupted record — skip it, the node's meta degrades to undefined
    }
  });
  return records;
};
